
















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component
export default class PackList extends Vue {
    @Prop({ type: Array, required: true }) public packs!: any;
    @Prop({ type: Number, required: true }) public total!: number;

    private getValue(item: any) {
        const value = item.quantity / item.product.displayDenominator;
        const units = item.product.unit && item.product.unit !== '' ? ' (' + item.product.unit + ')' : '';
        return value + units;
    }
}
